import { FC } from 'react';
import { Copyright } from './copyright';
import { ReportLayout } from '~/components/report-layout';

import './style.scss';

export const ReportBody: FC = () => {
  return (
    <ReportLayout className="copyright-container">
      <Copyright />
    </ReportLayout>
  );
};
